import regex from 'helpers/regex'

/**
 * Formats step-by-step a `string` value into a CNPJ, aceitando letras
 * maiúsculas nas 12 primeiras posições (CNPJ alfanumérico, IN RFB 2.229/2024).
 * @example ```js
 * formatToCNPJ('128781')
 * //=> '12.878.1'
 *
 * formatToCNPJ('32284981000138')
 * //=> '32.284.981/0001-38'
 *
 * formatToCNPJ('AB12CD34EFGH83')
 * //=> 'AB.12C.D34/EFGH-83'
 * ```
 * @param value - A `string` value of a CNPJ.
 */
const cnpj = (value) =>
  regex
    .onlyNumbersAndLetters(value)
    .slice(0, 14)
    .replace(/([0-9A-Z]{2})([0-9A-Z])/, '$1.$2')
    .replace(/([0-9A-Z]{3})([0-9A-Z])/, '$1.$2')
    .replace(/([0-9A-Z]{3})([0-9A-Z])/, '$1/$2')
    .replace(/([0-9A-Z]{4})(\d{1,2})$/, '$1-$2')

export default cnpj
